import { cn } from '@/lib/utils';
import useTranslation from '@/hooks/useTranslation';

interface ErrorMessageProps {
  message?: string;
  className?: string;
}

function ErrorMessage({ message, className = '' }: ErrorMessageProps) {
  const { lang } = useTranslation();

  if (!message) return null;

  const translatedMessage = message.startsWith('msg.') ? lang.get(message) : message;

  return <p className={cn('text-red-600 text-xs font-semibold', className)}>{translatedMessage}</p>;
}

export default ErrorMessage;
